import { motion } from "framer-motion";

const SHAPES = [
  // right zone
  { top: "16%", left: "56%", size: 10, duration: 4, delay: 0, kind: "square", tone: "brand" },
  { top: "38%", left: "74%", size: 6, duration: 3.2, delay: 0.4, kind: "dot", tone: "brand" },
  { top: "60%", left: "58%", size: 14, duration: 5, delay: 0.8, kind: "square", tone: "ink" },
  { top: "26%", left: "88%", size: 8, duration: 3.6, delay: 1.2, kind: "dot", tone: "ink" },
  { top: "72%", left: "80%", size: 5, duration: 2.8, delay: 0.2, kind: "dot", tone: "brand" },
  { top: "8%", left: "76%", size: 7, duration: 4.4, delay: 0.6, kind: "square", tone: "brand" },
  { top: "50%", left: "94%", size: 9, duration: 3.8, delay: 1, kind: "dot", tone: "ink" },
  { top: "4%", left: "62%", size: 5, duration: 3.4, delay: 1.6, kind: "dot", tone: "ink" },
  { top: "20%", left: "66%", size: 8, duration: 4.6, delay: 0.3, kind: "square", tone: "ink" },
  { top: "46%", left: "82%", size: 6, duration: 3, delay: 1.8, kind: "dot", tone: "brand" },
  { top: "82%", left: "62%", size: 11, duration: 5.2, delay: 0.5, kind: "square", tone: "brand" },
  { top: "90%", left: "88%", size: 6, duration: 3.6, delay: 1, kind: "dot", tone: "ink" },
  { top: "12%", left: "96%", size: 7, duration: 4, delay: 1.4, kind: "square", tone: "ink" },
  { top: "64%", left: "70%", size: 5, duration: 2.6, delay: 0.9, kind: "dot", tone: "brand" },
  { top: "34%", left: "60%", size: 6, duration: 3.8, delay: 0.2, kind: "dot", tone: "ink" },
  { top: "56%", left: "90%", size: 8, duration: 4.2, delay: 1.3, kind: "square", tone: "brand" },
  { top: "2%", left: "84%", size: 5, duration: 3.1, delay: 0.7, kind: "dot", tone: "brand" },
  { top: "78%", left: "94%", size: 12, duration: 5.4, delay: 0.1, kind: "square", tone: "ink" },
  { top: "44%", left: "64%", size: 5, duration: 2.9, delay: 1.7, kind: "dot", tone: "ink" },
  { top: "68%", left: "86%", size: 7, duration: 3.7, delay: 0.45, kind: "dot", tone: "brand" },
  // left zone
  { top: "6%", left: "4%", size: 6, duration: 3.5, delay: 0.3, kind: "dot", tone: "ink" },
  { top: "22%", left: "14%", size: 9, duration: 4.3, delay: 0.9, kind: "square", tone: "brand" },
  { top: "40%", left: "6%", size: 5, duration: 2.9, delay: 1.5, kind: "dot", tone: "brand" },
  { top: "58%", left: "18%", size: 7, duration: 3.9, delay: 0.6, kind: "dot", tone: "ink" },
  { top: "76%", left: "8%", size: 11, duration: 5, delay: 1.1, kind: "square", tone: "ink" },
  { top: "90%", left: "24%", size: 6, duration: 3.3, delay: 0.2, kind: "dot", tone: "brand" },
  { top: "12%", left: "30%", size: 5, duration: 2.7, delay: 1.3, kind: "dot", tone: "ink" },
  { top: "48%", left: "36%", size: 8, duration: 4.5, delay: 0.5, kind: "square", tone: "brand" },
  { top: "84%", left: "42%", size: 6, duration: 3.6, delay: 1.7, kind: "dot", tone: "ink" },
  { top: "30%", left: "48%", size: 5, duration: 3, delay: 0.8, kind: "dot", tone: "brand" },
  { top: "66%", left: "44%", size: 9, duration: 4.8, delay: 0.15, kind: "square", tone: "ink" },
  { top: "94%", left: "12%", size: 6, duration: 3.4, delay: 1, kind: "dot", tone: "brand" },
];

const TONE_CLASS = {
  brand: { fill: "bg-[#FF4F00]/70", outline: "border-[#FF4F00]/35" },
  ink: { fill: "bg-[#0A0A0A]/25", outline: "border-[#0A0A0A]/15" },
};

export default function FloatingShapes({ style, className = "" }) {
  return (
    <motion.div
      aria-hidden
      className={`hidden md:block absolute inset-0 pointer-events-none ${className}`}
      style={style}
    >
      {SHAPES.map((s, i) => {
        const tone = TONE_CLASS[s.tone];
        const filled = i % 2 === 0;
        return (
          <motion.span
            key={i}
            className={`absolute ${s.kind === "dot" ? "rounded-full" : ""} ${
              filled ? tone.fill : `border-2 ${tone.outline}`
            }`}
            style={{ top: s.top, left: s.left, width: s.size, height: s.size }}
            animate={{ y: [0, -16, 0] }}
            transition={{ duration: s.duration, repeat: Infinity, ease: "easeInOut", delay: s.delay }}
          />
        );
      })}
    </motion.div>
  );
}
